import { createAction } from "redux-actions";
import { NEW_VERIFICATE, UPDATE_VERIFICATE, FIND_VERIFICATE } from "../constants";
import { feathersCreateData, feathersFindDataAll } from "../services";

// cuando se dispara una notificacion
export const newVerificate = createAction(NEW_VERIFICATE,  (data) => feathersCreateData('verificates', data )() )
// CUANDO SE CONSULTA LA NOTIFICACION DESDE FEATHERS
export const updateVerificate = createAction(UPDATE_VERIFICATE, (data) => feathersCreateData('verificates', data )() )
export const findVerificate = createAction(FIND_VERIFICATE, (query) => feathersFindDataAll('verificates', query)() )